import { z } from 'zod';
// Catálogo configurable de tipologías de gasto (Ajustes → Tipologías de gasto).
// Mismo patrón que service-lines: `code` estable e inmutable (autogenerado del
// nombre en el backend), nombre editable.
const EXPENSE_CATEGORY_CODE_REGEX = /^[A-Z0-9_]+$/;
export const ExpenseCategoryDefDtoSchema = z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    active: z.boolean(),
    position: z.number().int(),
    isDefault: z.boolean(),
    createdAt: z.string().datetime(),
});
export const CreateExpenseCategorySchema = z.object({
    code: z
        .string()
        .min(2)
        .max(64)
        .regex(EXPENSE_CATEGORY_CODE_REGEX, 'Solo mayúsculas, dígitos y guion bajo')
        .transform((v) => v.toUpperCase())
        .optional(),
    name: z.string().min(2).max(200),
    description: z.string().max(1000).nullable().optional(),
    active: z.boolean().default(true),
    position: z.number().int().min(0).default(0),
    isDefault: z.boolean().default(false),
});
export const UpdateExpenseCategorySchema = CreateExpenseCategorySchema.omit({ code: true }).partial();
export const ExpenseCategoryListResponseSchema = z.object({
    items: z.array(ExpenseCategoryDefDtoSchema),
});
//# sourceMappingURL=expense-categories.js.map